<template>
	<div class="cneter">
		<div class="titleBiao"><span style="color:#c30d23;cursor:pointer;" @click="goBack(2)">{{package_name}}</span>
			/<span style="color:#c30d23;cursor:pointer;" @click="goBack(1)">{{title}}</span> / 课节制作</div>
		<div class="Template">
			<div class="content">
				<!-- <div class="nav_top clearfix">
					<div class="title fl_left">
						<i class="go_back" @click="goBack()"></i>{{title}}
					</div>
					<div class="btn_wrap fl_right">
						<router-link :to="{ name:'templet',params:{name:kjId}}" class="btn_preview btns" target="_blank">预览</router-link>
						<div class="btn_preserv" @click="save_json_request">保存</div>
					</div>
				</div> -->
				<div class="tep_con_wrap">
					<!-- <div class="tep_con"> -->
					<div class="bg_con clearfix" id="tep_ht">
						<div class="aside_left aside_left_zky fl_left"
							:class="{aside_left_zky_blue:module_list.tamplate_id == 8}">
							<div class="make_tit" @click="add_mod()"> + 添加栏目</div>

							<draggable class="lists" tag="ul" v-if='template_info' :list="template_info"
								:move="checkMove" v-bind="dragOptions" @start="dragging = true" @end="dragging = false"
								@update="updateSort">
								<li v-for="(item,key) in template_info" v-model="template_info"
									@click='tab_template(key)' :class="{zky_active :index == key}" @ready="ready()">
									<div class="icon_img">
										<div class="icon_img_src">
											<img :src="index == key ? item.img.src1 : item.img.src" alt="">
										</div>
										<span class="changeFont" v-if="item.name.length > 6" style="font-size:12px"
											:class="{zky_active :index == key && module_list.tamplate_id == 7,zky_active_blue :index == key &&module_list.tamplate_id == 8}">{{item.name}}</span>
										<span class="changeFont" v-else
											:class="{ zky_active :index == key &&module_list.tamplate_id == 7,zky_active_blue :index == key &&module_list.tamplate_id == 8 }">{{item.name}}</span>
										&nbsp;<span v-if="item.minute != 0 "
											:class="{ zky_active :index == key &&module_list.tamplate_id == 7,zky_active_blue :index == key &&module_list.tamplate_id == 8}">{{item.minute}}'</span>
									</div>
									<div class="editor_dele">
										<div class="icon_dele el-icon-delete" @click="dele_list(key)"></div>
										<div class="icon_editor el-icon-edit-outline" @click="editor_list(key)"></div>
									</div>
								</li>
							</draggable>
							<div class="total_minute">
								<div class="total_time">该课节共<span style="margin-left:5px;">{{totalMinute}}'</span></div>
							</div>
						</div>
						<div class="aside_right fl_left">
							<!-- <com1 :formData='module_list' ref="children"></com1> -->
							<temp_pink v-if="module_list.tamplate_id == 3" :formData='module_list' ref="children">
							</temp_pink>
							<temp_pink_2 v-if="module_list.tamplate_id == 4" :formData='module_list' ref="children">
							</temp_pink_2>
							<!-- <com2 v-if="module_list.tamplate_id == 8" :formData='module_list' ref="children"></com2>	
							<com3 v-if="module_list.tamplate_id == 1" :formData='module_list' ref="children"></com3> -->
						</div>
					</div>

					<!-- </div> -->
				</div>
				<div class="nav_bootom">
					<ul class="tep_list">
						<li v-for="(item,key) in imgs" :class="{active:module_list.tamplate_id == item.id}"
							@click="change(key)">
							<img :src="item.images" alt="">
							<div>{{item.name}}</div>
						</li>
					</ul>
				</div>
			</div>
		</div>
		<div class="addInfor" v-show="shows">
			<div class="addInfor_con">
				<div class="add_mod_title">
					<div class="mode_title fl_left">{{mod_title}}</div>
					<div class="qx-add fl_right" @click="reset()"></div>
				</div>
				<div class="clearfix edit_add_mod">
					<div class="lm_name fl_left">选择图标:</div>
					<div class="total_img fl_left" style="width:calc(100% - 75px)">
						<div v-for="(item,key) in icon_list" class="icon_imgs fl_left" @click="checkImg(key)">
							<img :src="item.src" alt="">
							<div class="marks" v-if="mark_show == item.src"><i class="fa fa-check"></i></div>
						</div>
					</div>
				</div>
				<div class="clearfix edit_add_mod">
					<div class="lm_name fl_left">栏目名称:</div>
					<div class="fl_left">
						<input type="text" class="input_con" v-model="name" placeholder="请输入栏目名称">
					</div>
				</div>
				<div class="clearfix edit_add_mod">
					<div class="lm_name fl_left">上课时长:</div>
					<div class="fl_left">
						<input type="text" class="input_con" v-model="time" placeholder="请输入上课时长"
							@input="time = time.replace(/[^\d]/g,'')">
					</div>
				</div>
				<!-- <div class="btn_wrapper"> -->
				<div class="btn btns" @click="sure(key)">确定</div>
				<!-- </div> -->
			</div>
		</div>
		<!-- <img src="static/imgs/111.jpeg"> -->
		<div class="loading_wrap" v-if="loading">
			<div class="loading_content">
				<i class="el-icon-loading"></i>
				<div>正在生成课件资源中，耐心等待</div>
			</div>
		</div>
	</div>
</template>
<script>
	import { Loading } from 'element-ui';
	import tem2 from './template/tep'
	import tem3 from './template/tep3'
	import temp_pink from './template/tepBw'
	import temp_pink_2 from './template/newBwtem'
	import tem1 from './template/zky_modul'
	import draggable from 'vuedraggable'
	export default {
		data() {
			return {
				icon_list: [
					{ src: "./static/imgs/images/AGUANG_n.png", src1: "./static/imgs/images/AGUANG_p.png" , src3: "imgs/images/AGUANG_n.png", src4: "imgs/images/AGUANG_p.png" },
					{ src: "./static/imgs/images/combine_n.png",src1: "./static/imgs/images/combine_p.png" , src3: "imgs/images/combine_n.png", src4: "imgs/images/combine_p.png" },
					{ src: "./static/imgs/images/music_n.png", src1: "./static/imgs/images/music_p.png" ,src3: "imgs/images/music_n.png", src4: "imgs/images/music_p.png" },
					{ src: "./static/imgs/images/Openingetiquette_n.png",src1: "./static/imgs/images/Openingetiquette_p.png" , src3: "imgs/images/Openingetiquette_n.png", src4: "imgs/images/Openingetiquette_p.png" },
					{ src: "./static/imgs/images/physical_n.png",src1: "./static/imgs/images/physical_p.png" , src3: "imgs/images/physical_n.png", src4: "imgs/images/physical_p.png" },
					{ src: "./static/imgs/images/quality_n.png",src1: "./static/imgs/images/quality_p.png" , src3: "imgs/images/quality_n.png", src4: "imgs/images/quality_p.png" },
					{ src: "./static/imgs/images/RitualClosing_n.png",src1: "./static/imgs/images/RitualClosing_p.png" , src3: "imgs/images/RitualClosing_n.png", src4: "imgs/images/RitualClosing_p.png" },
					// { src: "./static/imgs/rite.png", src3: "imgs/images/rite.png", src4: "imgs/images/rite.png" }
				]
				, title: ''   //标题
				, package_name: ''
				, icon_pc: ""     //pc电脑端
				, icon_app: ""    //移动app端
				, mark_show: ""   //选中图标
				, shows: false //编辑栏目
				, loading: false,
				index: 0,   //显示选中样式
				status: '',  //发布/保存
				mod_title: '新增栏目',
				time: '',   //上课时长
				//icon:'',   //图标
				name: '',    //栏目名称
				key: 0,     //编辑或添加
				// active: [false, false,false,false,false,false],    //模版
				template_info: [],   //左侧栏目内容
				sort_ids: [],   //排序id
				//isA:[],    //存储线上图标
				//isB:[],	   //存储线下图标
				//num:0,     //左侧栏目下表
				//img1:'',   //添加编辑转换成线下路径
				imgs: [
					// {
					// 	images:'./static/imgs/simle_img1.jpg',
					// 	id:3,
					// 	name:"艺籽"
					// },
					{
						images: './static/imgs/simle_img3.png',
						id: 3,
						name: "默认模板"
					},
					{
						images: './static/imgs/simle_img4.png',
						id: 4,
						name: "音乐模板"
					},
				],
				// moban:'com1',
				module_list: {
					module_id: '',
					tamplate_id: 3,
					course_id: '',  //舞种id
					package_id: '',   //期id
					table_id: '',     //课节id
					lanmu: 0,
					music: []
				},
				module_id: '',    //栏目id
				enabled: true,
				dragging: false
			}
		},
		/*beforeUpdate(){
	 		if (window.history && window.history.pushState) {
			    history.pushState(null, null, document.URL);
			    window.addEventListener('popstate', this.goBack, false);
			}
   		},*/
		computed: {
			totalMinute() {
				var total = 0;
				let _this = this;
				for (var i = 0; i < _this.template_info.length; i++) {
					total += parseInt(_this.template_info[i].minute)
				}
				return total
			},
			dragOptions() {
				return {
					animation: 200,
					disabled: false,
					ghostClass: "ghost"
				};
			}
		},
		components: {
			// "com2": tem2,
			"com1": tem1,
			temp_pink,
			temp_pink_2,
			// "com3": tem3,
			draggable
		},
		methods: {

			updateSort: function () {
				let _this = this;
				_this.sort_ids = []
				// console.log(_this.template_info)
				for (const arr of _this.template_info) {
					_this.sort_ids.push(arr.id);
				}
				window.console.log(_this.sort_ids);
				// return
				_this.$axios.post('sortcolumn', {
					column_ids: _this.sort_ids
				}).then((res) => {
					if (res.data.code == 200) {
						_this.tab_template(0)
						_this.$message({ type: 'success', message: '排序成功!' });
					} else {
						_this.$message.error(res.data.message)
					}
				}).catch((err) => {
					console.log(err)
				})
			},
			checkMove: function (e) {
				window.console.log("1");
			},
			checkImg(i) {
				let _this = this;
				_this.mark_show = _this.icon_list[i].src
				_this.icon_pc = _this.icon_list[i]
				// _this.icon_app = _this.icon_list[i]
			},
			goBack(index) {
				localStorage.removeItem('template')
				sessionStorage.removeItem('index')
				// sessionStorage.removeItem('changeNum')
				sessionStorage.removeItem('changeNum')
				sessionStorage.removeItem('formID')
				// localStorage.removeItem('ids')
				// this.$router.replace({path:'/manager/addCategory/centersCon/singleLesson',name:'singleLesson',query:{boolean:'false'}});
				if (index == 1) {
					// this.$router.go(-1);
					this.$router.push({
						path: '/manager/stu_class/class/singleLesson/addKj',
					})
				}
				if (index == 2) {
					// this.$router.go(-2);
					let luder = JSON.parse(localStorage.getItem("luder"));
					this.$router.push({
						path: '/manager/stu_class/class/singleLesson',
						// query:{
						// 	cate_id:luder.cate_id,
						// 	name:luder.cate_id
						// }
					})
				}
				if (index == 3) {
					// this.$router.go(-3);
					this.$router.push({
						path: '/manager/stu_class/class',
					})
				}
			},
			tab_template(i) {
				const _this = this;
				_this.index = i
				sessionStorage.setItem('index', i)
				sessionStorage.setItem('changeNum', _this.template_info[i].id)
				_this.get_module(i)
			},
			editor_list(i) {
				const _this = this;
				_this.key = 1
				_this.index = i
				_this.mark_show = _this.template_info[i].img.src
				_this.icon_pc = _this.template_info[i].img
				this.shows = true
				_this.name = _this.template_info[i].name;
				_this.time = _this.template_info[i].minute;
				_this.module_id = _this.template_info[i].id;
			},

			change_mod(x, index) {
				let _this = this;
				index = parseInt(index);
				if (_this.template_info[index].template_id != _this.imgs[x].id) {
					_this.$confirm('此操作将清空上模板内容, 是否继续?', '提示', {
						onfirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						_this.$axios.post('changetemplate', {
							column_id: _this.template_info[index].id,
							template_id: _this.imgs[x].id
						}).then((res) => {
							if (res.data.code == 200) {
								_this.$message({ type: 'success', message: '模板更改,删除成功!' });
								_this.template_info[index].template_id = _this.imgs[x].id
								_this.module_list.tamplate_id = _this.imgs[x].id;
								_this.tab_template(index)
							}
							else {
								_this.$message.error(res.data.message)
							}

						}).catch((err) => {
							console.log(err)
						})
					}).catch((error) => {
					});
				}
			},
			change(x) {
				const _this = this;
				if (_this.template_info.length > 0) {
					if (sessionStorage.getItem('index') != null) {
						_this.change_mod(x, sessionStorage.getItem('index'))
					}
					else {
						_this.change_mod(x, _this.index)
					}
				}
				else {
					_this.module_list.tamplate_id = _this.imgs[x].id;
				}
			},
			save_json_request() {
				const _this = this;
				//      	const packageInfor = JSON.parse(sessionStorage.getItem('package'))
				//      	if(_this.status){
				//      		_this.loading = true
				// 	_this.$axios.post('linuxjson',{
				//       		table_id:_this.module_list.table_id,
				//       		package_id:_this.module_list.package_id,
				//       		course_id:_this.module_list.course_id
				//       	}).then( respose =>{
				//       		if(respose.data.code == 200){
				//       			_this.$axios.post('zipmedia',{
				// 	course_id:_this.module_list.course_id,
				// 	package_id:_this.module_list.package_id,
				// 	resourse_name:packageInfor[0]
				// }).then((res)=>{
				// 	_this.loading = false
				// 	if(res.data.code == 200)
				// 	{
				// 		localStorage.removeItem('template')
				// 			sessionStorage.removeItem('index')
				//      			_this.$router.push({path:'/manager/addCategory/centersCon/singleLesson',query:{boolean:'false'}})
				// 	}
				// 	else
				// 	{
				// 		_this.$message.error(res.data.message);
				// 	}
				// })
				//       		}else{
				//       			_this.loading = false
				//       			_this.$message.error(respose.data.message)
				//       		}
				//       	}).catch( error =>{
				//       		console.log(error)
				//       	})
				//      	}
				//      	else{
				_this.loading = true
				_this.$axios.post('linuxjson', {
					table_id: _this.module_list.table_id,
					package_id: _this.module_list.package_id,
					course_id: _this.module_list.course_id
				}).then(res => {
					_this.loading = false
					if (res.data.code == 200) {
						localStorage.removeItem('template')
						sessionStorage.removeItem('index')
						_this.$router.push({ path: '/manager/addCategory/centersCon/singleLesson', query: { boolean: 'false' } })
					}
					else {
						_this.$message.error(res.data.message)
					}
				}).catch(error => {
					console.log(error)
				})
				// }
			},
			add_mod() {
				this.shows = true
				this.mod_title = '添加栏目'
				this.key = 0
			},
			reset() {
				this.shows = false
				this.name = '';
				this.icon_pc = '';
				this.icon_app = '';
				this.time = '';
			},
			sure(index) {
				const _this = this;
				if (_this.icon_pc == '') {
					_this.$message.error('请选择图标')
				}
				else if (_this.name == '') {
					_this.$message.error('请输入栏目名称')
				}
				else {
					if (_this.key == 0) {
						_this.$axios.post('addcolumn', {
							table_id: _this.module_list.table_id,
							template_id: _this.module_list.tamplate_id,
							name: _this.name,
							img: JSON.stringify(_this.icon_pc),
							minute: _this.time,
						}).then((res) => {
							if (res.data.code == 200) {
								_this.template_info.push({
									id: res.data.data,
									img: _this.icon_pc,
									img1: _this.icon_pc,
									minute: _this.time,
									name: _this.name,
									table_id: _this.module_list.table_id,
									template_id: _this.module_list.tamplate_id,
								})
								_this.$nextTick(() => {
									_this.tab_template(_this.template_info.length - 1)
								})
								_this.reset()
							}
							else if (res.data.code == 911) {
								_this.$message.error('该栏目名称已存在')
							}
							else {
								_this.$message.error(res.data.message)
							}
						}).catch((error) => {
							console.log(error)
						})
					}
					else {
						_this.$axios.post('editcolumn', {
							column_id: _this.module_id,
							name: _this.name,
							img: JSON.stringify(_this.icon_pc),
							minute: _this.time
						}).then((res) => {
							if (res.data.code == 200) {
								_this.template_info[_this.index].img = _this.icon_pc
								_this.template_info[_this.index].minute = _this.time
								_this.template_info[_this.index].name = _this.name
								_this.reset()
							}
							else if (res.data.code == 911) {
								_this.$message.error('该栏目名称已存在')
							}
							else {
								_this.$message.error(res.data.message)
							}
						}).catch((err) => {
							console.log(err)
						})
					}
				}
			},
			dele_list(i) {
				let _this = this;
				_this.$confirm('此操作将永久删除' + _this.template_info[i].name + ', 是否继续?', '提示', {
					onfirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					_this.$axios.post('deletecolumn', {
						column_id: _this.template_info[i].id,
					}).then(res => {
						if (res.data.code == 200) {
							_this.$message({ type: 'success', message: '删除成功!' });
							_this.template_info.splice(i, 1)
							if (_this.template_info.length > 0) {
								_this.tab_template(_this.template_info.length - 1)
							}
							else {
								_this.get_module(0)
							}
						}
						else {
							_this.$message.error(res.data.message)
						}
					}).catch(err => {
						console.log(error)
					})
				}).catch(error => { });
			},
			get_module(index) {
				let _this = this;
				_this.index = index
				_this.template_info = []
				let loadingInstance = Loading.service({ fullscreen: true });
				_this.$axios.post('getcolumnlist', {
					table_id: _this.module_list.table_id
				}).then(res => {
					loadingInstance.close();
					if (res.data.code == 200) {
						_this.template_info = res.data.data;
						_this.$nextTick(() => {
							if (_this.template_info.length == 0) {
								// _this.module_list.module_id = 3;
								_this.module_list.tamplate_id = 3
								_this.module_list.music = []
							}
							else {
								_this.module_list.lanmu = _this.template_info.length;
								_this.module_list.module_id = _this.template_info[index].id;
								_this.module_list.tamplate_id = _this.template_info[index].template_id;
								_this.module_list.music = _this.template_info[index].music ? _this.template_info[index].music : [];
							}
						})

					}
					else {
						_this.$message.error(res.data.message)
					}
				}).catch((err) => {
					console.log(err)
				})
			},
		},
		created() {
			let _this = this;
			// _this.status = sessionStorage.getItem('status') 
			var list = JSON.parse(sessionStorage.getItem('lesson'));
			_this.module_list.course_id = list.course_id;
			_this.module_list.package_id = list.package_id;
			_this.module_list.table_id = list.table_id;
			_this.title = list.name;
			_this.package_name = list.package_name;
			if (sessionStorage.getItem('changeNum') != null) {
				this.module_list.module_id = parseInt(sessionStorage.getItem('changeNum'))
			}
			if (sessionStorage.getItem('index') != null) {
				_this.get_module(sessionStorage.getItem('index'))
			}
			else {
				_this.get_module(0)
			}
		},
        /*destroyed(){
		  	window.removeEventListener('popstate', this.goBack, false);
		},*/
	};
</script>
<style scoped>
	.titleBiao {
		line-height: 68px;
		color: #303030;
		font-size: 18px;
	}

	.content {
		min-width: 1152px;
		margin: 0 auto;
		width: 100%
	}

	.tep_con_wrap {
		height: 647px;
		background: #fff;
		margin-top: 10px;
		margin-bottom: 20px;
		padding-top: 20px;
	}

	.bg_con {
		min-width: 1000px;
		min-height: 563px;
		background: #fff;
		margin: 0 auto;
		padding: 1px 0 0;
		width: 90%;
		/*background: url(../../../static/imgs/start.png) 0 0 no-repeat;*/
		background-size: cover;
		margin-top: 20px;
	}

	.tep_con_changeBack {
		background: url(../../../static/imgs/startback.png) 0 0 no-repeat;
		background-size: cover;
	}

	/*.bg_con{}*/
	.aside_left {
		width: 170px;
		min-height: 520px;
		background: rgba(176, 100, 99, 0.9);
		box-sizing: border-box;
	}

	/*绿色#3aafa1*/
	.aside_right {
		width: calc(100% - 170px);
	}

	.aside_left_changeColor {
		background: rgba(230, 175, 169, 0.6);
	}

	/* .aside_left_zky{background: rgba(230, 175, 169, 0.95);} */
	.aside_left_zky_blue {
		background: #5ea5f5;
	}

	.go_back {
		width: 27px;
		height: 27px;
		display: inline-block;
		vertical-align: middle;
		background: url(../../../static/imgs/back_purple.png) 0 center no-repeat;
		background-size: 100%;
		margin-right: 12px;
		cursor: pointer;
	}

	.make_tit {
		width: 140px;
		height: 44px;
		background: #fff;
		border-radius: 6px;
		box-sizing: border-box;
		color: #333;
		line-height: 44px;
		position: relative;
		margin: 20px auto;
		cursor: pointer;
		text-align: center
	}

	/*.make_tit>spandisplay: block;}*/
	.lists {
		color: #fff;
		font-size: 14px;
		width: 170px;
		height: 455px;
		overflow-y: auto;
	}

	.lists::-webkit-scrollbar {
		width: 4px;
		height: 4px;
	}

	.lists::-webkit-scrollbar-thumb {
		border-radius: 5px;
		-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		background: rgba(0, 0, 0, 0.2);
	}

	.lists::-webkit-scrollbar-track {
		-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		border-radius: 0;
		background: rgba(0, 0, 0, 0.1);
	}

	.lists>li {
		cursor: pointer;
		position: relative;
		border-bottom: 1px solid rgba(255, 255, 255, .7);
		height: 72px;
		line-height: 70px;
		display: flex;
    	align-items: center;
	}

	.lists>li.changeColor {
		border-bottom: 1px solid #fff;
	}

	.editor_dele {
		background: rgba(0, 0, 0, .4);
		position: absolute;
		top: 0;
		left: 0;
		height: 72px;
		width: 36px;
		flex-direction: column;
		display: none;
	}

	.icon_dele,
	.icon_editor {
		width: 36px;
		height: 36px;
		line-height: 36px;
		text-align: center;
	}

	.icon_dele:hover,
	.icon_editor:hover {
		color: rgb(255, 201, 87);
	}

	.lists li:hover .editor_dele {
		display: flex;
	}



	.addInfor {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: 99;
		padding-top: 8%;
		background: rgba(0, 0, 0, .75);
	}

	.addInfor_con {
		position: relative;
		width: 450px;
		min-height: 300px;
		background: #fff;
		border-radius: 4px;
		box-sizing: border-box;
		margin: 0 auto;
	}

	.add_mod_title {
		height: 40px;
		line-height: 40px;
		background: #f4f5f9;
		border-radius: 4px 4px 0 0;
		box-sizing: border-box;
		padding: 0 10px;
	}

	.qx-add {
		background: url(../../../static/imgs/quxiao.png) center center no-repeat;
		width: 14px;
		height: 40px;
		background-size: 100%;
		cursor: pointer;
	}

	.edit_add_mod {
		padding: 0 15px;
		line-height: 36px;
		margin-top: 15px;
	}

	.lm_name {
		line-height: 36px;
		margin-right: 10px;
		width: 65px;
		text-align: right;
	}

	.total_img .icons_img,
	.total_img .icon_imgs {
		background: #d2b17e;
		width: 36px;
		height: 36px;
		margin: 0 10px 5px 0px;
		cursor: pointer;
		position: relative;
		text-align: center;
	}

	.total_img .icons_img img,
	.total_img .icon_imgs img {
		max-height: 36px;
		max-width: 36px;
		vertical-align: middle;
	}

	.input_con {
		width: 260px;
		height: 36px;
		background: #f6f6f6;
		box-sizing: border-box;
		padding-left: 11px;
		font-size: 14px;
		color: #333;
		outline: none;
		border-radius: 4px;
		border: 1px solid #ddd;
	}

	img {
		display: inline-block;
	}

	.btn,
	.btn_preserv {
		width: 106px;
		height: 36px;
		box-sizing: border-box;
		border-radius: 2px;
		line-height: 36px;
		text-align: center;
		font-size: 14px;
		cursor: pointer;
		margin: 10px auto 0;
		background: #c30d23;
		color: #fff;
		border: 1px solid #c30d23;
	}

	.marks {
		position: absolute;
		top: 0;
		left: 0;
		background: #c30d23;
		line-height: 36px;
		text-align: center;
		width: 36px;
		height: 36px;
		color: #fff;
	}

	.btn_preserv {
		margin: 0;
		margin-right: 10px;
	}


	.nav_bootom {
		background: #fff;
		box-sizing: border-box;
		padding: 12px 6px 13px 20px;
	}

	.tep_list {
		display: flex;
		align-items: center;
		/* flex-wrap:wrap; */
		width: 100%;
		overflow-y: hidden;
		overflow-x: auto;
	}

	.tep_list::-webkit-scrollbar {
		width: 4px;
		height: 4px;
	}

	.tep_list::-webkit-scrollbar-track {
		background: #f6f6f6;
		border-radius: 2px;
	}

	.tep_list::-webkit-scrollbar-thumb {
		background: #aaa;
		border-radius: 2px;
	}

	.tep_list::-webkit-scrollbar-thumb:hover {
		background: #747474;
	}

	.tep_list::-webkit-scrollbar-corner {
		background: #f6f6f6;
	}

	.tep_list li {
		width: 186px;
		height: 157px;
		margin: 0 18px 10px;
		box-sizing: border-box;
		cursor: pointer;
	}

	.tep_list li div {
		text-align: center;
	}

	.tep_list li img {
		width: 186px;
		height: 125px;
		border: 2px solid #fff;
	}

	.tep_list li.active img {
		border: 2px solid #dfb055;
	}

	.tep_list li div:last-child {
		margin-top: 14px;
		font-size: 14px;
		color: #333;
	}

	/*.activeClass{color: #ffc957;}*/
	.zky_active {
		color: #ffc957;
	}

	/*  绿色background: rgba(230, 175, 169, 0.6); */
	.zky_active_blue {
		background: #378ec4;
		color: #fff;
	}

	.title {
		line-height: 64px;
		font-size: 14px;
		color: #333;
	}

	.btn_wrap {
		display: flex;
		justify-content: center;
		align-items: center;
		height: 64px;
	}

	.btn_preview {
		background: #fff;
		border: 1px solid #ddd;
		color: #333;
	}

	.nav_top {
		box-sizing: border-box;
		padding-left: 30px;
		height: 64px;
		background: #fff;
	}

	.upload-content {
		background: #f4f4f4;
		width: 380px;
		height: 240px;
		border-radius: 10px;
	}

	.icon_img {
		display: flex;
		align-items: center;
		cursor: move;
	}

	.icon_img_src {
		width: 40px;
		text-align: center;
	}

	.icon_img_src>img {
		max-width: 25px;
		max-height: 25px;
		vertical-align: middle;
		margin-bottom: 7px;
	}

	.total_minute {
		box-sizing: border-box;
		text-align: center;
		color: #fff;
		height: 42px;
		line-height: 42px
	}

	.total_time {
		font-size: 16px;
	}

	/*.total_time>span{font-size: 32px;font-weight: bold;}*/
	.loading_wrap {
		width: 100%;
		height: 100%;
		background: rgba(0, 0, 0, 0.8);
		position: fixed;
		top: 50%;
		left: 50%;
		transform: translateX(-50%) translateY(-50%);
		z-index: 9999;
	}

	.loading_content {
		position: absolute;
		top: 50%;
		left: 50%;
		width: 100%;
		transform: translateX(-50%) translateY(-50%);
		font-size: 100px;
		color: #409EFF;
		text-align: center;
	}

	.loading_content div {
		font-size: 24px;
	}

	.changeFont {
		display: inline-block;
		line-height: 20px;
	}

	.ghost {
		opacity: 0.5;
		background: #c8ebfb;
	}
</style>


// WEBPACK FOOTER //
// src/components/index/makTep.vue